import { createSlice } from '@reduxjs/toolkit';
import { setDefinitions } from '../actions/SetDefinitions';
const initialState = {};
export const hastaReceiversSlice = createSlice({
    name: 'hasta_receivers',
    initialState,
    reducers: {
        hastaReceiversCleared: () => {
            return {};
        },
        hastaReceiverUpdated: (state, action) => {
            state[action.payload.id] = action.payload;
        },
        hastaReceiverDeleted: (state, action) => {
            delete state[action.payload];
        },
        hastaReceiversReplaced: (state, action) => {
            const newState = {};
            for (const o of action.payload) {
                newState[o.id] = o;
            }
            return newState;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(setDefinitions, (_, action) => {
            const newState = {};
            for (const o of action.payload.hasta_receivers) {
                newState[o.id] = o;
            }
            return newState;
        });
    }
});
export const selectHastaReceivers = (state) => state.definitions.hasta_receivers;
export const selectHastaReceiver = (id) => (state) => id == undefined ? undefined : state.definitions.hasta_receivers[id];
export const { hastaReceiversCleared, hastaReceiverUpdated, hastaReceiverDeleted, hastaReceiversReplaced } = hastaReceiversSlice.actions;
export const hastaReceiverAdded = hastaReceiverUpdated;
export default hastaReceiversSlice.reducer;
